module.exports = __webpack_public_path__ + "img/woocommerce-logo.84c82b30.png";